// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Select, SelectProps } from 'antd';
import { SelectValue } from 'antd/lib/select';
import React, { ReactElement } from 'react';
import { Option } from './Option';

import './THSelect.scss';

interface THSelectProps<T extends SelectValue> extends SelectProps<T> {
    borderless?: boolean;
    errorless?: boolean;
}

export const THSelect = <T extends SelectValue>({
    borderless = false,
    errorless = false,
    dropdownClassName,
    className,
    ...props
}: THSelectProps<T>): ReactElement => (
    <Select<T>
        className={classList('th-select', className, { 'no-border': borderless, 'no-error': errorless })}
        {...props}
        dropdownClassName={classList('th-select__dropdown', dropdownClassName)}
        status={errorless ? ('ok' as '') : props.status}
    />
);

THSelect.Option = Option;
THSelect.OptGroup = Select.OptGroup;
